export default __webpack_public_path__ + "static/photo6usluge-bc6e02b6c347c443e38153dfc6b6b21d.png";